<template>
  <div :class="['axiome-logique-container', 'axiome-logique-one-of']">
    <!--Affichage Operand-->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">one
      of</span>
    <span class="brace-container-left"></span>
    <template v-if="oneOf">
      <PropertyValue :values="oneOfLiterals" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge" />
    </template>
    <span class="brace-container-right"></span>
  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeOneOf",
  computed: {
    oneOfLiterals() {
      let result = [];
      this.oneOf.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    },
    blankNodes() {
      let blankNodes = [];
      this.oneOf.forEach(element => {
        blankNodes.push(...element.blankNodes);
      });
      return blankNodes;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    oneOf: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
